<template>
    <div>
        <div class="hero int-page">
            <TDSHead/>
        </div>
        <div class="container py-4 py-lg-8 mt-4 mt-lg-8">
            <div class="row">
                <div class="col-12 mb-3 mb-4">
                    <h1 class="font-weight-bold text-primary">{{$t('privacy.title')}}</h1>
                </div>
            </div>
            <div class="row docs">
                <div class="col-md-12">
                    <div v-html="$t('privacy.text')"></div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>
</template>

<script>
    import BaseVue from "../views/BaseVue"

    export default {
        extends: BaseVue,
        name: 'chi-siamo',
        metaInfo() {
            return {
                title: 'Privacy Policy - TDS.sport',
            }
        }
    }
</script>
